// Styles here will override Bulma styles
import styled from '@emotion/styled';
import media from 'css-in-js-media';
import arrow from '../../../assets/images/chevron-right-blue.svg';
import Element from '../../element';

// TINY TOP NAV

export const TinyNav = styled.div`
  background: white;
  padding-top: 0px;
  min-height: 2rem;
  display: flex;
  flex-direction: row;
  position: fixed;
  top: 0;
  width: 100% !important;

  ${media('<desktop')} {
    display: none;
  }
`;

export const TinyNavMenu = styled.div`
  background: white;
  padding-top: 0;
  min-height: 2rem;
  display: flex;
  flex-direction: row;
  border-bottom: 1px solid rgb(229, 232, 237);
  font-size: 12px !important;
  width: 100% !important;
`;

export const TinyNavBarHiringLink = styled(Element)`
  display: flex;
  align-items: center;
  font-weight: 700;
  font-size: 12px;
  line-height: 15px;
  color: #0069ff;
`;

export const TinyNavBarEndDivider = styled.div`
  display: flex;
  align-items: center;
  color: #0069ff;
  margin-left: 16px;
  font-weight: 700;
`;

export const TinyNavBarItem = styled(Element)`
  color: #5b6987 !important;
  cursor: pointer;
  font-family: 'WorkSans-Medium', 'Helvetica', 'sans-serif';
  height: 40px;
  margin: 0;
  padding: 0;
  padding-left: 25px;
  display: flex;
  align-items: center;

  :hover > p {
    color: #0069ff;
  }

  :hover p:after {
    background: url(${arrow}) no-repeat center;
  }
`;

export const TinyNavBarEnd = styled.div`
  margin-right: 30px;
  display: flex;
  position: absolute;
  right: 0;
`;
